export default __webpack_public_path__ + "static/media/2019_thumb.4e75e8d7.jpg";